import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { frequencyEnum, mealTypesEnum } from "../../../util/enum";
import { getRightPackageUom } from "../../../util/function";

const PrescriptionView = ({ prescriptions, showShortName = false }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { clinicStocks } = useSelector((state) => state?.clinic);

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId,
    );
    return reqStock?.stockBatch ?? [];
  };

  const getNameWithValue = (itm) => {
    if (itm?.shortName?.length > 0) return itm?.shortName;
    if (itm?.name?.length > 0) return itm?.name;
    if (itm?.plName?.length > 0) return itm?.plName;
    return "";
  };

  const renderData = (
    li,
    //  currPrd
  ) => {
    const reqFreq = Array.isArray(li?.frequencyDuration)
      ? li?.frequencyDuration
          ?.map((key) => frequencyEnum[key])
          ?.filter(Boolean)
          ?.join(", ")
      : typeof li?.frequencyDuration === "string"
        ? li?.frequencyDuration
        : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
            li?.night ? "1" : "0"
          }`;

    return (
      <div
        className="flex-row ph10 mv5 prescription-print-row"
        key={`rec_${li?.id ?? li?.i}`}
      >
        <div className="prescription-print-cell">
          <Typography className="fs12 font-medium black4">
            {showShortName ? getNameWithValue(li) : (li?.name ?? li?.plName)}
          </Typography>
        </div>
        {/* <div className="w10Per pr5">
          <Typography className="fs12 font-medium black4">
            {li?.quantity ?? li?.qty ?? "1"}
            {li?.subUnit === "Unit" || li?.unitType === "Unit"
              ? currPrd?.measurementUnit
              : currPrd?.subMeasurementUnit}
          </Typography>
        </div> */}
        <div className="prescription-print-cell">
          <Typography className="fs12 font-medium black4">
            {li?.dosage}
            {getRightPackageUom(
              li?.packageUom
                ? (getBatchList(li?.stockId)?.find(
                    (bat) => bat?.batchId === li?.batchId,
                  )?.packageUom ?? "")
                : (getBatchList(li?.stockId)?.[0]?.packageUom ?? ""),
              true,
            )}
          </Typography>
        </div>
        <div className="prescription-print-cell">
          <div className="fs12 font-medium black4">{reqFreq}</div>
        </div>
        {/* <div className="w13Per pr5">
          {(typeof li?.frequency === "string" && li?.frequency?.length > 0) ||
          (typeof li?.frequencyDuration === "string" &&
            li?.frequencyDuration?.length > 0) ||
          li?.morning ||
          li?.afternoon ||
          li?.night ? (
            <div className="fs12 font-medium black4">
              {typeof (li?.frequency ?? li?.frequencyDuration) === "string"
                ? (li?.frequency ?? li?.frequencyDuration)
                : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
                    li?.night ? "1" : "0"
                  }`}
            </div>
          ) : // <div className="flex-start">
          //   <div className="blue-back-con fs12 font-medium">
          //     {typeof (li?.frequency ?? li?.frequencyDuration) === "string"
          //       ? li?.frequency ?? li?.frequencyDuration
          //       : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
          //           li?.night ? "1" : "0"
          //         }`}
          //   </div>
          // </div>
          null}
        </div> */}
        <div className="prescription-print-cell">
          <Typography className="fs12 font-medium black4">
            {li?.route ?? ""}
          </Typography>
        </div>
        <div className="prescription-print-cell">
          <Typography className="fs12 font-medium black4">
            {li?.duration ?? "1"} days
          </Typography>
        </div>
        <div className="prescription-print-cell">
          <div className="fs12 font-medium black4">
            {mealTypesEnum?.[li?.meal ?? ""]}
          </div>
        </div>
        <div className="prescription-print-cell">
          <div className="fs12 font-medium black4">{li?.remark ?? ""}</div>
        </div>
      </div>
      // <div className="gray-back-con" key={`rec_${li?.id ?? li?.i}`}>
      //   <div className="flex-row flex-row-wrap">
      //     <div className="w85Per">
      //       <div className="flex-row flex-row-wrap">
      //         <div className="font-bold fs12 black">
      //           {li?.name ?? li?.plName}
      //         </div>
      //         <div className="flex-row flex-center ml10">
      //           <div className="gray-dot" />
      //           <div className="font-medium fs12 black4 ml5">Quantity:</div>
      //           <div className="txt-regular fs12 black4 ml3">
      //             {li?.quantity ?? li?.qty ?? "1"}{" "}
      //             {li?.subUnit === "Unit" || li?.unitType === "Unit"
      //               ? currPrd?.measurementUnit
      //               : currPrd?.subMeasurementUnit}
      //           </div>
      //         </div>
      //         <div className="flex-row flex-center ml10">
      //           <div className="gray-dot" />
      //           <div className="font-medium fs12 black4 ml5">Dosage:</div>
      //           <div className="txt-regular fs12 black4 ml3">
      //             {li?.dosage}
      //             {getRightPackageUom(
      //               li?.batchId
      //                 ? getBatchList(li?.stockId)?.find(
      //                     (bat) => bat?.batchId === li?.batchId
      //                   )?.packageUom ?? ""
      //                 : getBatchList(li?.stockId)?.[0]?.packageUom ?? ""
      //             )}
      //           </div>
      //         </div>
      //         <div className="flex-row flex-center ml10">
      //           <div className="gray-dot" />
      //           <div className="font-medium fs12 black4 ml5">Duration:</div>
      //           <div className="txt-regular fs12 black4 ml3">
      //             {li?.duration ?? "1"} days
      //           </div>
      //         </div>
      //         {li?.meal?.length > 0 ? (
      //           <div className="flex-row flex-center ml10">
      //             <div className="gray-dot" />
      //             <div className="txt-regular fs12 black4 ml5">
      //               {li?.meal === "afterMeal"
      //                 ? "After Meal"
      //                 : li?.meal === "beforeMeal"
      //                 ? "Before Meal"
      //                 : ""}
      //             </div>
      //           </div>
      //         ) : null}
      //       </div>
      //     </div>
      //     {(typeof li?.frequency === "string" && li?.frequency?.length > 0) ||
      //     (typeof li?.frequencyDuration === "string" &&
      //       li?.frequencyDuration?.length > 0) ||
      //     li?.morning ||
      //     li?.afternoon ||
      //     li?.night ? (
      //       <div className="flex-center">
      //         <div className="blue-back-con fs12 font-medium">
      //           {typeof (li?.frequency ?? li?.frequencyDuration) === "string"
      //             ? li?.frequency ?? li?.frequencyDuration
      //             : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
      //                 li?.night ? "1" : "0"
      //               }`}
      //         </div>
      //       </div>
      //     ) : null}
      //   </div>
      // </div>
    );
  };

  const areAllEmpty = (prescriptions ?? reqDet?.prescription)?.every(
    (pres) => ((pres?.prescriptionDetails ?? [])?.length ?? 0) === 0,
  );

  return (
    <div className="prescription-print-table">
      {/* <div className="blk-hor-split mv3" /> */}
      {areAllEmpty ? null : (
        <>
          <div className="flex-row-ali-cen ph10 prescription-print-col-head">
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">Name</Typography>
            </div>
            {/* <div className="prescription-print-cell">
          <Typography className="fs12 txt-semi-bold black">Qty</Typography>
        </div> */}
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">Dose</Typography>
            </div>
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">
                Frequency
              </Typography>
            </div>
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">
                Route
              </Typography>
            </div>
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">
                Duration
              </Typography>
            </div>
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">
                Instructions
              </Typography>
            </div>
            <div className="prescription-print-cell">
              <Typography className="fs12 txt-semi-bold black">
                Remarks
              </Typography>
            </div>
          </div>
          <div className="blk-hor-split mb3 mt10" />
        </>
      )}
      {(prescriptions ?? reqDet?.prescription)?.map((pres, i) => {
        const reqProcedDetList = [...(pres?.prescriptionDetails ?? [])]?.sort(
          (a, b) => (a?.id ?? a?.detailId) - (b?.id ?? b?.detailId),
        );
        return (
          <div className="mv5" key={`mainLi_${i}`}>
            {reqProcedDetList?.map((li, i) => {
              // const currPrd = clinicStocks?.data?.find(
              //   (dta) => dta?.stockId === li?.stockId,
              // );
              return renderData(
                li,
                // currPrd
              );
            })}
            {(pres?.remark || pres?.remarks || "")?.length > 0 ? (
              <div className="prescription-print-notes">
                <Typography
                  className={`fs12 txt-semi-bold black ${areAllEmpty ? "" : "mt10"}`}
                >
                  Notes
                </Typography>
                <Typography
                  className="fs12 txt-regular black"
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                  component="div"
                >
                  {(pres?.remark || pres?.remarks || "")
                    ?.split("\n")
                    ?.map((line, index) => (
                      <div key={index}>{line || "\u00A0"}</div>
                    ))}
                </Typography>
              </div>
            ) : (
              ""
            )}
          </div>
        );
      })}
      {/* <div className="blk-hor-split mv3" /> */}
    </div>
  );
};

export default PrescriptionView;
